/**
 * Utilidades para manejar sufijos de unidades
 */

export const KNOWN_SUFFIXES = [' LA', ' LI', ' Ru', ' R2'] as const
export type KnownSuffix = (typeof KNOWN_SUFFIXES)[number]

/**
 * Detecta si un catalogID tiene un sufijo conocido
 */
export function hasKnownSuffix(catalogID: string): boolean {
  return KNOWN_SUFFIXES.some((suffix) => catalogID.includes(suffix))
}

/**
 * Extrae el sufijo de un catalogID
 */
export function extractSuffix(catalogID: string): KnownSuffix | null {
  for (const suffix of KNOWN_SUFFIXES) {
    if (catalogID.includes(suffix)) {
      return suffix
    }
  }
  return null
}

/**
 * Obtiene el catalogID base sin sufijo
 */
export function getBaseCatalogID(catalogID: string): string {
  for (const suffix of KNOWN_SUFFIXES) {
    if (catalogID.includes(suffix)) {
      return catalogID.replace(suffix, '')
    }
  }
  return catalogID
}

/**
 * Construye un catalogID con sufijo
 */
export function buildCatalogIDWithSuffix(baseCatalogID: string, suffix: KnownSuffix): string {
  return baseCatalogID + suffix
}

/**
 * Actualiza un glbPath con sufijo
 */
export function updateGlbPathWithSuffix(glbPath: string, suffix: KnownSuffix): string {
  // Remover sufijo existente si lo tiene
  const baseGlbPath = glbPath.replace(/ (LA|LI|Ru|R2)\.glb$/, '.glb')
  // Agregar el nuevo sufijo
  return baseGlbPath.replace('.glb', suffix + '.glb')
}

/**
 * Actualiza una referencia con sufijo
 */
export function updateReferenciaWithSuffix(referencia: string, suffix: KnownSuffix): string {
  // Remover sufijo existente si lo tiene
  const baseReferencia = referencia.replace(/ (LA|LI|Ru|R2)$/, '')
  // Agregar el nuevo sufijo
  return baseReferencia + suffix
}

/**
 * Mapea unidades con sus sufijos
 */
export function mapUnitsWithSuffixes(items: Map<string, any>): Map<string, KnownSuffix> {
  const unitsWithSuffixes = new Map<string, KnownSuffix>()

  items.forEach((item, id) => {
    if (item.type === 'linkedItem') {
      const catalogID = item.catalogID.toString()
      const suffix = extractSuffix(catalogID)
      if (suffix) {
        unitsWithSuffixes.set(id, suffix)
      }
    }
  })

  return unitsWithSuffixes
}
